import React from 'react';
import Icon from '../../../components/AppIcon';

const ScoringDashboard = ({ stats, leads = [] }) => {
  const metrics = [
    { label: 'Total Leads', value: stats?.totalLeads?.toLocaleString() || leads?.length?.toString() || '0', icon: 'Users', color: 'text-blue-600', bg: 'bg-blue-50' },
    { label: 'Average Score', value: stats?.avgScore?.toString() || '0', icon: 'Star', color: 'text-yellow-600', bg: 'bg-yellow-50' },
    { label: 'High Score Leads', value: stats?.highScoreLeads?.toString() || leads?.filter(l => (l?.lead_score || 0) >= 80)?.length?.toString() || '0', icon: 'TrendingUp', color: 'text-green-600', bg: 'bg-green-50' },
    { label: 'Converted', value: stats?.convertedLeads?.toString() || leads?.filter(l => l?.is_converted)?.length?.toString() || '0', icon: 'Trophy', color: 'text-purple-600', bg: 'bg-purple-50' }
  ];

  return (
    <div className="space-y-6">
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
        {metrics?.map((metric, index) => (
          <div key={index} className="bg-card border border-border rounded-lg p-6 shadow-elevation-1">
            <div className="flex items-center space-x-4">
              <div className={`p-3 rounded-lg ${metric?.bg}`}>
                <Icon name={metric?.icon} size={24} className={metric?.color} />
              </div>
              <div>
                <p className="text-sm text-muted-foreground">{metric?.label}</p>
                <p className="text-2xl font-bold text-foreground">{metric?.value}</p>
              </div>
            </div>
          </div>
        ))}
      </div>

      {leads?.length === 0 && (
        <div className="bg-card border border-border rounded-lg p-12 text-center">
          <Icon name="Brain" size={48} className="text-muted-foreground mx-auto mb-4 opacity-40" />
          <h3 className="text-lg font-semibold text-foreground mb-2">No Leads to Score</h3>
          <p className="text-muted-foreground">Add leads to your pipeline to start AI-powered scoring</p>
        </div>
      )}
    </div>
  );
};

export default ScoringDashboard;